<template>
  <div>
    <v-card class="pa-4 groups-card">
       <v-card-title class="d-flex align-center pb-2 v-card-title">
        <v-icon left class="mr-2">fa-solid fa-users</v-icon>
        {{ $t('views.settings.groups') }}
      </v-card-title>
      <v-card-text>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in groups"
            :key="index"
            class="border-bottom"
            @click="editRecordTable(item)"
            style="cursor: pointer;"
          >
            <v-list-item-icon>
              <v-icon>fa-solid fa-users</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="#1D1B59"
          dark
          class="rounded-lg"
          @click="onNewRecordTable()"
        >
          <v-icon left>fa-solid fa-plus</v-icon>
          {{ $t("components.views.settings.groups.new_group") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    
    <!-- Modal para crear/editar grupo -->
    <v-dialog
      v-model="dialogNew"
      max-width="800px"
      persistent
    >
      <ModalFormGroup
        :key="componentKey"
        :edit="edit"
        :data="itemGroup"
        @closeForm="onCloseForm"
        @reloadTable="onRealoadTable"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ModalFormGroup: () =>
      import(
        /* webpackChunkName: "ModalFormGroup" */ "@/components/views/Settings/Groups/Modals/ModalFormGroup/ModalFormGroup.vue"
      ),
  },
  data() {
    return {
      componentKey: 0,
      dialogNew: false,
      itemGroup: {},
      edit: false,
      groups: [],
    };
  },
  name: "Groups",
  watch: {
    token(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (!this.token) {
          window.location.href = process.env.VUE_APP_URL_LOGIN_SUITE;
        }
      }
    },
    searchField(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$nextTick(() => {
          this.onRealoadTable();
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      search: "search/search",
    }),
    idCompany() {
      let userMap = JSON.parse(this.user);
      return userMap.user.idCompany;
    },
    url() {
      return `/Groups/groupsByIdCompany`;
    },
    urlCount() {
      return `/Groups/GetByIdCompanyCountAsync`;
    },
    searchField() {
      return this.search;
    },
  },
  metaInfo() {
    return {
      title: this.$t("views.settings.groups"),
    };
  },
  mounted() {
    if (this.typeUser == 2) {
      this.$router.push({ name: "Error" });
    }
    this.loadGroups();
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("loader", ["showLoader"]),

    async loadGroups() {
      this.showLoader(true);
      try {
        const response = await this.axios.get(this.url);
        this.groups = response.data || [];
      } catch (error) {
        console.error('Error loading groups:', error);
        this.groups = [];
        this.showSnack({
          text: error.response?.data || 'Error al cargar los grupos',
          title: this.$t("components.views.settings.groups.error"),
          name: "error",
        });
      } finally {
        this.showLoader(false);
      }
    },

    onNewRecordTable() {
      this.componentKey += 1;
      this.dialogNew = true;
    },

    editRecordTable(item) {
      this.itemGroup = Object.assign({}, item);
      this.edit = true;
      this.componentKey += 1;
      this.dialogNew = true;
    },

    async deleteItem(id) {
      if (
        await this.$root.$confirm(
          this.$t("components.views.settings.groups.delete_group_confirmation"),
          this.$t("components.views.settings.groups.are_you_sure_you_want_to_delete_this_record"),
          "eliminar"
        )
      ) {
        this.showLoader(true);
        await this.axios
          .delete(`/Groups/Delete/${id}`)
          .then(() => {
            this.showSnack({
              text: this.$t("components.views.settings.groups.group_deleted_successfully"),
              title: this.$t("components.views.settings.groups.success"),
              name: "success",
            });
            this.onRealoadTable();
          })
          .catch((error) => {
            this.showSnack({
              text: error.response.data,
              title: this.$t("components.views.settings.groups.error"),
              name: "error",
            });
          })
          .finally(() => {
            this.showLoader(false);
          });
      }
    },

    onCloseForm() {
      this.dialogNew = false;
      this.edit = false;
    },

    onRealoadTable() {
      this.loadGroups();
    },
  },
};
</script>

<style scoped>
.rounded-lg {
  border-radius: 8px !important;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.v-list-item {
  padding: 12px 16px;
}

.v-list-item__title {
  font-size: 16px;
  font-weight: 500;
}

.v-card-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 16px 20px;
}

.headline {
  font-size: 18px !important;
  font-weight: 600;
}

.groups-card {
  max-height: 400px;
  display: flex;
  flex-direction: column;
}

.groups-card .v-card__text {
  flex: 1 1 auto;
  max-height: 400px; /* ~3 ítems visibles antes de scroll */
  overflow-y: auto;
}

.groups-card .v-card__actions {
  flex-shrink: 0;
}
</style>